import moment from "moment-timezone";

export const IST_TZ = "Asia/Kolkata";
const IST_OUTPUT_FORMAT = "YYYY-MM-DDTHH:mm:ssZ";

function isValidDate(d) {
  return d instanceof Date && !Number.isNaN(d.getTime());
}

export function parseApiIstToMoment(value) {
  if (!value) return null;
  const m = moment.tz(value, IST_TZ);
  return m.isValid() ? m : null;
}

export function apiIstStringToPickerDate(value) {
  const m = parseApiIstToMoment(value);
  if (!m) return null;
  return new Date(
    m.year(),
    m.month(),
    m.date(),
    m.hour(),
    m.minute(),
    m.second(),
    m.millisecond()
  );
}

export function istNowPickerDate({ withTime = true } = {}) {
  const m = moment.tz(IST_TZ);
  return new Date(
    m.year(),
    m.month(),
    m.date(),
    withTime ? m.hour() : 0,
    withTime ? m.minute() : 0,
    withTime ? m.second() : 0,
    withTime ? m.millisecond() : 0
  );
}

export function pickerDateToIstMoment(date) {
  if (!isValidDate(date)) return null;
  return moment.tz(
    [
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
      date.getMilliseconds(),
    ],
    IST_TZ
  );
}

export function formatIstOffsetFromPickerDate(date) {
  const m = pickerDateToIstMoment(date);
  return m ? m.format(IST_OUTPUT_FORMAT) : null;
}

export function formatApiIstStringWithOffset(value) {
  const m = parseApiIstToMoment(value);
  return m ? m.format(IST_OUTPUT_FORMAT) : null;
}

export function formatExDateWithCurrentIstTime(pickerDate) {
  const mDate = pickerDateToIstMoment(pickerDate);
  if (!mDate) return null;
  const mNow = moment.tz(IST_TZ);
  const combined = mDate
    .clone()
    .hour(mNow.hour())
    .minute(mNow.minute())
    .second(mNow.second())
    .millisecond(mNow.millisecond());
  return combined.format(IST_OUTPUT_FORMAT);
}

export function formatIstDateDisplay(value, fmt = "DD-MM-YYYY") {
  const m = parseApiIstToMoment(value);
  return m ? m.format(fmt) : "";
}

